import { Navigate } from 'react-router-dom';
import { LoadingSpinner } from '@demand-iq/ui';
import useDefaultLandingRoute from 'hooks/useDefaultLandingRoute';

/**
 * Resolves "/" to the first destination this user can actually open. Reached on login, from both
 * error pages ("Go Home") and after a company switch, so every caller that cannot resolve a landing
 * itself hands off to "/" rather than guessing.
 *
 * The table itself lives in `useDefaultLandingRoute`.
 */
const DefaultLandingRedirect = (): JSX.Element => {
  const { route, isPending } = useDefaultLandingRoute();

  if (isPending) {
    return <LoadingSpinner className="h-64" />;
  }

  return <Navigate to={route} replace />;
};

export default DefaultLandingRedirect;
